/**
 * Model to set up a new Admin Onboarding
 */
import { Company } from './CompanyOnboardingModels';
import { ApiResponse, PaginatedApiRequest, PaginatedApiResponse } from './ServiceModels';

/**
 * Admin request interface
 */
export interface AdminOnboardingRequest {
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  username: string;
  status: string;
  companyCode?: string;
  marketId?: string;
}

/**
 * Admin request interface
 */
export interface AdminUpdateRequest {
  id: string;
  firstName: string;
  lastName: string;
  role: string;
  username: string;
}

/**
 * Admin allowed operations
 */
export enum AllowedAdminOperations {
  CAN_EDIT = 'CAN_EDIT',
  CAN_DELETE = 'CAN_DELETE',
  CAN_IMPERSONATE = 'CAN_IMPERSONATE',
}

/**
 * Admin model
 */
export interface Admin {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  username: string;
  status: string;
  bans: string[];
  company: CompanyAdmin;
  marketId: string;
  allowedOperations: AllowedAdminOperations[];
}

export interface CompanyAdmin extends Omit<Company, 'companyCode' | 'bans'> {
  code: string;
}

/**
 * API response for GET/administrators/id
 */
export interface AdminResponse extends ApiResponse, Admin {}

/**
 * API response for POST /onboard/roles
 */
export interface AvailableRolesResponse extends ApiResponse {
  roles: string[];
}

/**
 * Create admin response
 */
export interface AdminCreateResponse extends ApiResponse {
  [key: string]: string | number;
}

/**
 * Admin list request
 * Request params to get the list of admins
 */
export interface AdminsListRequest extends PaginatedApiRequest {
  filter: string;
  companyId: string;
}

/**
 * Paginated admins list
 * Response from API
 */
export interface AdminsListResponse extends PaginatedApiResponse {
  administrators: Admin[];
}
